import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MarketShopSettingsModel } from '@/models'

export type GetMarketShopSettingsRequest = {
  marketShopId?: number
}

export const getMarketShopSettingsQueryKey = (data: GetMarketShopSettingsRequest) => [
  'useGetMarketShopSettings',
  data,
]

export const getMarketShopSettings = async (
  data: GetMarketShopSettingsRequest,
  signal?: AbortSignal,
) => {
  const response = await authAPI.get<MarketShopSettingsModel>(
    `/market-shop/settings/${data.marketShopId}`,
    { signal },
  )
  return response.data
}

export const useGetMarketShopSettings = (data: GetMarketShopSettingsRequest) => {
  return useQuery({
    enabled: !!data.marketShopId,
    queryFn: ({ signal }) => getMarketShopSettings({ ...data }, signal),
    queryKey: getMarketShopSettingsQueryKey(data),
  })
}
